import { useParams, Link } from 'react-router-dom';

import { getDateWithTimeZone } from '@/helpers/dateHelpers';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import LoadingPage from '@/components/common/LoadingPage';
import Error from '@/components/common/Error';

import OrderView from './OrderView';

import { useOrder } from '@/data/order';
import { useActivitiesV2 } from '@/data/activity';

const ViewOrderPage = () => {
  const params = useParams();
  const order = useOrder(params.id);
  const activities = useActivitiesV2();

  if (order.isLoading && !order.data) {
    return <LoadingPage />;
  }
  if (activities.isLoading && !activities.data) {
    return <LoadingPage />;
  }

  if (order.error) {
    return <Error error="There was an error loading the order" />;
  }
  if (activities.error) {
    return <Error error="There was an error loading activities" />;
  }

  return (
    <div className="max-w-6xl mx-auto">
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/order">Orders</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>#{order.data.orderNum}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card>
        <CardHeader className="border-b bg-muted ">
          <CardTitle className="flex justify-between items-center mb-4">
            Order #{order.data.orderNum}
          </CardTitle>
          <span className="text-sm text-muted-foreground block m-0">
            Customer
          </span>
          <h4 className="text-lg font-semibold m-0">
            {order.data.userFirstname} {order.data.userLastname} (
            {order.data.userEmail})
          </h4>
          <span className="text-sm text-muted-foreground block m-0">
            Order placed on {getDateWithTimeZone(order.data.createdAt)}
          </span>
        </CardHeader>
        <CardContent className="pt-6">
          <OrderView orderId={params.id} />
        </CardContent>
      </Card>
    </div>
  );
};

export default ViewOrderPage;
